module.exports = __webpack_public_path__ + "img/rating.7d38f959.png";